import { PricingErrorType } from '@/features/public/booking/types/PricingErrorType.ts';

const pricingErrorTypeLabels: Record<PricingErrorType, string> = {
  [PricingErrorType.NO_BASE_PRICE_AVAILABLE_FOR_PARTICIPANT_WITH_AGE]:
    'brak ceny podstawowej dla tego wieku',
  [PricingErrorType.REQUIRED_OPTION_NOT_SELECTED]:
    'nie wybrano wymaganej opcji dodatkowej',
  [PricingErrorType.OPTION_VARIANT_NOT_FOUND]:
    'wybrany wariant opcji nie istnieje',
  [PricingErrorType.OPTION_PRICE_NOT_FOUND]: 'brak ceny dla wybranej opcji',
  [PricingErrorType.OPTION_PRICE_NOT_AVAILABLE_FOR_AGE]:
    'wybrana cena opcji nie jest dostępna dla tego wieku',
  [PricingErrorType.OPTION_MULTI_SELECT_NOT_ALLOWED]:
    'ta opcja nie pozwala na wybór wielu wariantów',
  [PricingErrorType.OPTION_ARCHIVED]:
    'wybrana opcja nie jest już dostępna w ofercie',
  [PricingErrorType.OPTION_VARIANT_ARCHIVED]:
    'wybrany wariant opcji nie jest już dostępny w ofercie',
  [PricingErrorType.OPTION_PRICE_ARCHIVED]:
    'wybrana cena opcji nie jest już dostępna w ofercie',
  [PricingErrorType.TOUR_FULL]: 'brak wolnych miejsc na wyjeździe',
  [PricingErrorType.OPTION_FULL]: 'brak wolnych miejsc w wybranej opcji',
  [PricingErrorType.OPTION_VARIANT_FULL]:
    'brak wolnych miejsc w wybranym wariancie opcji',
  [PricingErrorType.TRANSPORT_NOT_OFFERED]: 'ten wyjazd nie oferuje transportu',
  [PricingErrorType.TRANSPORT_SELECTION_REQUIRED]:
    'wybór transportu jest wymagany',
  [PricingErrorType.TRANSPORT_VARIANT_NOT_FOUND]:
    'wybrany wariant transportu nie istnieje',
  [PricingErrorType.TRANSPORT_AGE_NOT_ELIGIBLE]:
    'wybrany wariant transportu nie jest dostępny dla tego wieku',
  [PricingErrorType.TRANSPORT_VARIANT_SOLD_OUT]:
    'brak wolnych miejsc w wybranym wariancie transportu',
};

export const getPricingErrorTypeLabel = (type: PricingErrorType): string =>
  pricingErrorTypeLabels[type] ?? type;

/**
 * Ten sam błąd jako zdanie — do komunikatu przy polu, którego dotyczy.
 * Fragmenty wyżej doklejają się do nazwiska uczestnika na liście zbiorczej i
 * samodzielnie się nie czytają („brak wolnych miejsc w wybranej opcji" pod
 * kafelkiem opcji brzmi jak urwane zdanie).
 */
const pricingErrorSentences: Record<PricingErrorType, string> = {
  [PricingErrorType.NO_BASE_PRICE_AVAILABLE_FOR_PARTICIPANT_WITH_AGE]:
    'Dla tego wieku nie ma ceny na tym wyjeździe.',
  [PricingErrorType.REQUIRED_OPTION_NOT_SELECTED]:
    'Wybór tej opcji jest obowiązkowy.',
  [PricingErrorType.OPTION_VARIANT_NOT_FOUND]:
    'Wybrany wariant już nie istnieje — wybierz inny.',
  [PricingErrorType.OPTION_PRICE_NOT_FOUND]:
    'Wybrany wariant nie ma ceny — wybierz inny.',
  [PricingErrorType.OPTION_PRICE_NOT_AVAILABLE_FOR_AGE]:
    'Wybrany wariant nie jest dostępny w tym wieku.',
  [PricingErrorType.OPTION_MULTI_SELECT_NOT_ALLOWED]:
    'W tej opcji można wybrać tylko jeden wariant.',
  [PricingErrorType.OPTION_ARCHIVED]:
    'Ta opcja nie jest już dostępna w ofercie.',
  [PricingErrorType.OPTION_VARIANT_ARCHIVED]:
    'Wybrany wariant nie jest już dostępny w ofercie.',
  [PricingErrorType.OPTION_PRICE_ARCHIVED]:
    'Cena wybranego wariantu nie jest już dostępna.',
  [PricingErrorType.TOUR_FULL]: 'Na tym wyjeździe nie ma już wolnych miejsc.',
  [PricingErrorType.OPTION_FULL]: 'W tej opcji nie ma już wolnych miejsc.',
  [PricingErrorType.OPTION_VARIANT_FULL]:
    'W wybranym wariancie nie ma już wolnych miejsc.',
  [PricingErrorType.TRANSPORT_NOT_OFFERED]:
    'Ten wyjazd nie oferuje transportu.',
  [PricingErrorType.TRANSPORT_SELECTION_REQUIRED]:
    'Wybór transportu jest wymagany.',
  [PricingErrorType.TRANSPORT_VARIANT_NOT_FOUND]:
    'Wybrany wariant transportu już nie istnieje — wybierz inny.',
  [PricingErrorType.TRANSPORT_AGE_NOT_ELIGIBLE]:
    'Wybrany wariant transportu nie jest dostępny w tym wieku.',
  [PricingErrorType.TRANSPORT_VARIANT_SOLD_OUT]:
    'W wybranym wariancie transportu nie ma już wolnych miejsc.',
};

export const getPricingErrorSentence = (type: PricingErrorType): string =>
  pricingErrorSentences[type] ?? getPricingErrorTypeLabel(type);
